module.exports = __webpack_public_path__ + "3e830c6fe8370080ddb135b1440219e2.jpg";